import { Injectable } from "@angular/core";

import { KycVerificationState } from "./kyc-verification.reducer";

@Injectable({
	providedIn: "root",
})
export class KycVerificationSelector {
	getKnowYourCustomerUrl() {
		return (state: KycVerificationState) => state.kycVerification.uri;
	}

	isBusy() {
		return (state: KycVerificationState) => state.kycVerification.isBusy;
	}

	height() {
		return (state: KycVerificationState) => state.kycVerification.height;
	}
}
